/**
 * `list-cloudeq-entities` — R-91-1 / D-91-2, D-91-5 · CLM-91.
 *
 * The active rows of the `clm.cloudeq_entity` registry in `sort_order` — the
 * web's selects (Analytics, Search, the Contract record override) and the
 * dashboard tiles need the display names, and the fifth entity's name is TBC
 * (Q-91-1), so nothing is a constant. A reference-table read: `cloudeq_entity`
 * has no `contract_key`, so there is no scope predicate — and no audit row
 * (`writes_audit_row: false`, the `pipeline-status` precedent). Gate
 * `contract:read`.
 */
import { z } from 'zod';
import { CloudeqEntitySchema } from '../domain/cloudeq-entity.js';
export const ListCloudeqEntitiesRequestSchema = z.object({}).strict();
export const ListCloudeqEntitiesResponseSchema = z.object({ entities: z.array(CloudeqEntitySchema) }).strict();
//# sourceMappingURL=list-cloudeq-entities.js.map